import { get } from "./axiosApi";
import { env } from "utils/env";
import { objToQueryString } from "utils/functions";

const url = env.REACT_APP_LEASING_API_URL;

const loadDocumentRights = (documentId, siteId, documentTypeId) => {
  const qs = objToQueryString({ documentId, siteId, documentTypeId });
  return get(`${url}/leasingdocument/rights?${qs}`);
};

const exp = {
  loadDocumentRights
};
export default exp;
